import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import {
  FormControl,
  Grid,
  TextField,
  useMediaQuery,
  Select,
  MenuItem,
  Box,
  Button,
  Typography,
  Container,
} from '@mui/material';
import { isEqual } from 'lodash';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';
import { actions } from '../../../actions';
import { useDispatch, useSelector } from 'react-redux';
import CircularProgress from '@mui/material/CircularProgress';
import Text from '../../../shared/Text';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    message: {
      width: '100%',
      '&::-webkit-scrollbar': {
        width: '.5em',
      },
      '&::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0,0,0,.2)',
      },
    },
    buttonLy: {
      display: 'flex',
      alignItems: 'center',
    },
    buttonSave: {
      marginBlock: 16,
    },
    selectRef: {
      fontSize: 14,
      color: '#bbb',
    },
  }));
};

const keys = {
  inPerson: 'inPerson',
  telemedicine: 'telemedicine',
};

const ModalitiesMessages = () => {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const organization = useSelector((state) => state.app.organization);
  const firestore = useFirestore();
  const appDispatch = useDispatch();
  const [actualKey, setActualKey] = useState(keys.inPerson);
  const [businessRules, setBusinessRules] = useState();
  const [actualBusinessRules, setActualBusinessRules] = useState();
  const [inProgress, setInProgress] = useState(false);
  const configuration = useSelector((state) => state.app.labelsConfiguration);

  useEffect(() => {
    if (
      organization &&
      organization.businessRules &&
      organization.businessRules.appointmentsModality &&
      !actualBusinessRules
    ) {
      setBusinessRules(organization.businessRules.appointmentsModality);
      setActualBusinessRules(organization.businessRules.appointmentsModality);
    }
  }, [actualBusinessRules, organization.businessRules]);

  useEffect(() => {
    if (
      organization &&
      organization.businessRules &&
      organization.businessRules.appointmentsModality
    ) {
      setBusinessRules(organization.businessRules.appointmentsModality);
      setActualBusinessRules(organization.businessRules.appointmentsModality);
    }
  }, [organization.id]);

  const handleUpdate = () => {
    setInProgress(true);
    firestore
      .collection(collections.organizations)
      .doc(organization.id)
      .get()
      .then((res) => {
        const org = res.data();
        firestore
          .collection(collections.organizations)
          .doc(organization.id)
          .update({
            businessRules: {
              ...org.businessRules,
              appointmentsModality: {
                ...actualBusinessRules,
              },
            },
          })
          .then((res) => {
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: 'Actualizado exitosamente!',
                snackbarSeverity: 'success',
              },
            });
            setInProgress(false);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log(err);
            appDispatch({
              type: actions.alert,
              alert: {
                snackbarOpen: true,
                snackbarMessage: 'Error al actualizar organización!',
                snackbarSeverity: 'error',
              },
            });
            setInProgress(false);
          });
      });
  };

  return (
    <Box pb={4}>
      <Container maxWidth="lg">
        <Grid container>
          <Grid xs={12}>
            {configuration && configuration.modalities && (
              <Text configuration={configuration} propName="modalities" />
            )}
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box my={2}>
              <FormControl fullWidth variant="outlined" className={classes.formControl}>
                <Typography className={classes.selectRef}>Origen</Typography>
                <Select value={actualKey} onChange={(event) => setActualKey(event.target.value)}>
                  <MenuItem value={keys.inPerson}>PRESENCIAL</MenuItem>
                  <MenuItem value={keys.telemedicine}>TELECONSULTA</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
          <Grid item sm={12} className={classes.buttonLy}>
            {!isEqual(businessRules, actualBusinessRules) && (
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonSave}
                onClick={handleUpdate}
              >
                Guardar
              </Button>
            )}
            {inProgress && (
              <Box mx={2}>
                <CircularProgress />
              </Box>
            )}
          </Grid>
          <Grid item sm={12}>
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                multiline
                placeholder="Pre mensaje"
                inputProps={{ className: classes.message }}
                value={
                  (actualBusinessRules &&
                    actualBusinessRules[actualKey] &&
                    actualBusinessRules[actualKey].messages &&
                    actualBusinessRules[actualKey].messages.savedAppPreMessage) ||
                  ''
                }
                onChange={(e) => {
                  const messages =
                    (actualBusinessRules[actualKey] && actualBusinessRules[actualKey].messages) ||
                    {};
                  setActualBusinessRules({
                    ...actualBusinessRules,
                    [actualKey]: {
                      messages: {
                        ...messages,
                        savedAppPreMessage: e.target.value,
                      },
                    },
                  });
                }}
                rows={6}
                variant="outlined"
                spellCheck="false"
              />
            </FormControl>
          </Grid>
          <Grid item sm={12}>
            <Box my={2}>
              <FormControl className={classes.formControl} fullWidth>
                <TextField
                  multiline
                  placeholder="Información importante"
                  inputProps={{ className: classes.message }}
                  value={
                    (actualBusinessRules &&
                      actualBusinessRules[actualKey] &&
                      actualBusinessRules[actualKey].messages &&
                      actualBusinessRules[actualKey].messages.savedAppImportantInfo) ||
                    ''
                  }
                  onChange={(e) => {
                    setActualBusinessRules({
                      ...actualBusinessRules,
                      [actualKey]: {
                        messages: {
                          ...actualBusinessRules[actualKey].messages,
                          savedAppImportantInfo: e.target.value,
                        },
                      },
                    });
                  }}
                  rows={6}
                  variant="outlined"
                  spellCheck="false"
                />
              </FormControl>
            </Box>
          </Grid>
          <Grid item sm={12}>
            <FormControl className={classes.formControl} fullWidth>
              <TextField
                multiline
                inputProps={{ className: classes.message }}
                placeholder="Post mensaje"
                value={
                  (actualBusinessRules &&
                    actualBusinessRules[actualKey] &&
                    actualBusinessRules[actualKey].messages &&
                    actualBusinessRules[actualKey].messages.savedAppPostMessage) ||
                  ''
                }
                onChange={(e) => {
                  setActualBusinessRules({
                    ...actualBusinessRules,
                    [actualKey]: {
                      messages: {
                        ...actualBusinessRules[actualKey].messages,
                        savedAppPostMessage: e.target.value,
                      },
                    },
                  });
                }}
                rows={6}
                variant="outlined"
                spellCheck="false"
              />
            </FormControl>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

const Props = {};

ModalitiesMessages.propTypes = Props;

export default ModalitiesMessages;
